/**
 * Account-level chat (the cross-plan "Ask {assistant} about anyone you care for"
 * assistant) is only useful once a caregiver is juggling several plans, so it's
 * gated on a minimum plan count — independent of paid status. A paid user with
 * one or two plans still doesn't see it.
 *
 * Single source of truth for every surface that offers it:
 *   - the AI tab in navigation/useRoutes.ts
 *   - the "Ask {assistant}…" bar in screens/ProjectsScreen.tsx
 *
 * This list has already gone stale once — HomeScreen (whose copy of the bar
 * went with the cross-plan Home, 2026-10-06) was added after it was
 * written, shipped with a bare `plans.length > 0`, and offered cross-plan chat
 * to accounts with a single plan. A comment cannot enforce itself, so the
 * property is a test now: constants/__tests__/accountChatGate.test.ts finds
 * every file carrying the entry copy and requires it to compare against this
 * constant. Keep the list current for readers; the test is what holds.
 */
export const MIN_PLANS_FOR_ACCOUNT_CHAT = 3;
